import React from "react";
import st from "@/styles/LoginPage.module.scss";
import clsx from "clsx";
import WriteOTPSecondStep from "@/pages/login/elemsV2/WriteOTPSecondStep.tsx";
import WritePinSecondStep from "@/pages/login/elemsV2/WritePinSecondStep.tsx";


const StepTwoForm:React.FC = ({}) => {
    const queryParams = new URLSearchParams(location.search);
    const isPinParam = queryParams.get("isPin");


    return (
        <div className={clsx(st.log_vars, st.next_steps)}>

            {isPinParam === "true" ? (
                <WritePinSecondStep/>
            ) : (
                <WriteOTPSecondStep />
            )}

        </div>
    )
}




export default StepTwoForm